<template>
  <v-container text-xs-center fluid>
    <v-row justify="center">
      <v-col cols="12" md="8">
        <h2 class="text-center">GoDial Mobile Call Recording</h2>
        <p class="text-center">
          Record Calls Directly on Your Phone, choose what you want to record.
        </p>
        <v-card class="pa-4" style="border-radius: 10px;">
          <iframe
            width="100%"
            height="500"
            src="https://www.youtube.com/embed/1glIP7nby8A"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </v-card>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" md="8" class="text-center">
        <h2>Why Choose GoDial Mobile Call Recording?</h2>
        <p>
          GoDial simplifies mobile call recording and integrates it seamlessly
          with your workflow.
        </p>
      </v-col>
    </v-row>
    <v-row justify="center" class="mt-4">
      <v-col cols="12" md="3">
        <v-card class="pa-4 text-center" outlined>
          <v-icon large class="mb-2">mdi-cellphone</v-icon>
          <h4>Record Calls Directly on Your Phone:</h4>
          <p>No extra devices needed</p>
        </v-card>
      </v-col>
      <v-col cols="12" md="3">
        <v-card class="pa-4 text-center" outlined>
          <v-icon large class="mb-2">mdi-phone-in-talk</v-icon>
          <h4>Record Both Incoming and Outgoing Calls:</h4>
          <p>Capture the complete conversation.</p>
        </v-card>
      </v-col>
      <v-col cols="12" md="3">
        <v-card class="pa-4 text-center" outlined>
          <v-icon large class="mb-2">mdi-currency-inr</v-icon>
          <h4>No Extra Charges:</h4>
          <p>Call recording is included free with the basic GoDial plan.</p>
        </v-card>
      </v-col>
      <v-col cols="12" md="3">
        <v-card class="pa-4 text-center" outlined>
          <v-icon large class="mb-2">mdi-play-pause</v-icon>
          <h4>Full Control:</h4>
          <p>Choose which calls to record for maximum flexibility.</p>
        </v-card>
      </v-col>
    </v-row>

    <v-container class="mt-10">
      <h2 class="text-center font-weight-bold">
        How to Record Calls from Your Smartphone
      </h2>
      <v-row class="mt-5">
        <!-- Step 1 -->
        <v-col cols="12" md="12">
          <v-row align="center">
            <v-col cols="12" md="6">
              <h3 class="step-number">01</h3>
              <h4 class="font-weight-bold">Enable on Dashboard</h4>
              <ul>
                <li>
                  Login to the GoDial Dashboard using the Manager Account
                  Credentials
                </li>
                <li>
                  Go to the Recording Tab on the left-hand panel and select
                  Mobile Call Recording
                </li>
                <li>
                  Go to the Team and Members Tab, click on the edit icon, and
                  enable recording under permissions
                </li>
              </ul>
            </v-col>
            <v-col cols="12" md="6">
              <v-img
                src="https://your-image-url.com/step1-image.jpg"
                alt="Enable on Dashboard"
                contain
              ></v-img>
            </v-col>
          </v-row>
        </v-col>

        <!-- Step 2 -->
        <v-col cols="12" md="12" class="mt-10">
          <v-row align="center">
            <v-col cols="12" md="6">
              <v-img
                src="https://your-image-url.com/step2-image.jpg"
                alt="Record Calls on your Smartphone"
                contain
              ></v-img>
            </v-col>
            <v-col cols="12" md="6">
              <h3 class="step-number">02</h3>
              <h4 class="font-weight-bold">Record Calls on your Smartphone</h4>
              <ul>
                <li>Login to the GoDial Enterprise App and make a call</li>
                <li>
                  Once the call is connected, click on the recording button on
                  your phone
                </li>
                <li>
                  After adding the disposition, click Next. Your call recording
                  file has been sent to the GoDial web dashboard
                </li>
              </ul>
            </v-col>
          </v-row>
        </v-col>

        <!-- Step 3 -->
        <v-col cols="12" md="12" class="mt-10">
          <v-row align="center">
            <v-col cols="12" md="6">
              <h3 class="step-number">03</h3>
              <h4 class="font-weight-bold">Listen to Call Recordings</h4>
              <ul>
                <li>
                  Login to the GoDial Web-Dashboard and go to the Reports and
                  Analytics Tab
                </li>
                <li>
                  Go to the Master tab, click on a recording file for a call
                  made, and listen to the conversation
                </li>
                <li>You can download the recording file for the call</li>
              </ul>
            </v-col>
            <v-col cols="12" md="6">
              <v-img
                src="https://your-image-url.com/step3-image.jpg"
                alt="Listen to Call Recordings"
                contain
              ></v-img>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import moment from "moment-timezone";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      selectedOption: "mobile", // Default selected option
      recordCallsWithTrueCaller: false,
      enableRecording: false,
      panel: [],
      addStorage: 0,
      loading: false,
      recordsPerPage: [1, 5, 15, 30, 60],

      page: 1,
      pageCount: 0,
      totalRecords: 0,
      records: 15,

      files: [],
      fileTableHeaders: [
        {
          text: "File Name",
          align: "start",
          sortable: false,
          value: "name",
        },
        { text: "Size", value: "size", sortable: false },
        { text: "Time", value: "createdOn", sortable: false },
        { text: "", value: "downlaod", sortable: false },
        { text: "", value: "delete", sortable: false },
      ],
    };
  },
  created() {
    this.fetchFiles();
    this.recordCallsWithTrueCaller = this.$store.state.companyDetails.recordCallsWithTrueCaller;
  },
  computed: {
    ...mapGetters(["ENDPOINT", "teams", "selectedTeam", "companyDetails"]),
  },
  methods: {
    learnMore(option) {
      if (option === "mobile") {
        this.$router.push("/mobile-recording");
      } else if (option === "cloud") {
        this.$router.push("/cloud-recording");
      }
    },
    openYouTube(url) {
      window.open(url, "_blank");
    },
    selectOption(option) {
      this.selectedOption = option;
      console.log(`${option} Call Recording Selected`);
    },
    removeRecording(item) {
      console.log("item 123", item);

      this.$http
        .delete(`${this.ENDPOINT}/attachments/${item}`)
        .then((response) => {
          this.loader = false;
          this.fetchFiles();
          this.$swal({ type: "success", text: "Successfully deleted" });
          // this.close();
        })
        .catch((err) => {
          this.loader = false;
          this.$swal({ type: "error", text: "Something went wrong" });
        });
    },
    download(src, dialingOpt) {
      if (src != "") {
        if (dialingOpt == "exotel") {
          console.log(src);
          var a = document.createElement("a");

          a.href = src;
          a.setAttribute("download", src.toString());
          a.target = "_blank";
          a.click();
        } else {
          console.log(src);
          var au = document.createElement("a");

          au.href = `${this.$store.state.ENDPOINT}/storages/get/${src}?access_token=${this.$store.getters.user.token}`;
          au.setAttribute("download", src.toString());
          au.target = "_blank";
          au.click();
        }
      }
    },
    mathfloorCustom(value) {
      if (value == 0) {
        return "0MB";
      }

      var filterValueInBytes = value * 1024 * 1024;

      var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      var i = parseInt(
        Math.floor(Math.log(filterValueInBytes) / Math.log(1024))
      );

      var finalValueData =
        Math.round(filterValueInBytes / Math.pow(1024, i), 2) + "" + sizes[i];

      return finalValueData;
    },
    nextSet() {
      this.page++;
      this.pagination();
    },
    prevSet() {
      this.page--;
      this.pagination();
    },
    async pagination() {
      try {
        this.pageCount = Math.ceil(this.totalRecords / this.records);
        if (this.page > this.pageCount) {
          this.page = 1; //set default
        }
        this.files = await this.fetchFiles(
          this.records,
          this.records * this.page - this.records
        );

        // Save default pagination of seperate pages
        this.paginate[
          this.$router.currentRoute.name
            .toString()
            .trim()
            .replace(/ /g, "")
            .toLowerCase()
        ] = {
          page: this.page,
          pageCount: this.pageCount,
          records: this.records,
          totalRecords: this.totalRecords,
        };
        this.$store.commit("setPagination", this.paginate);

        return;
      } catch (e) {
        this.loader = false;
      }
    },

    async fetchFiles(limit, skip) {
      if (typeof limit == "undefined" && typeof skip == "undefined") {
        try {
          var where = {
            companyId: this.$store.getters.user.companyId,
          };
          var response = await this.$http.get(
            this.$store.getters.ENDPOINT +
              "/attachments/count?where=" +
              encodeURIComponent(JSON.stringify(where))
          );

          this.totalRecords = response.body.count;
        } catch (e) {
          console.log(e);
        }
      }
      this.loading = true;

      this.files = [];
      if (limit == undefined || limit == undefined) {
        limit = 5;
        skip = 0;
      }
      var filter = {
        skip: skip,
        limit: limit,
        order: "createdOn DESC",
        where: {
          companyId: this.$store.getters.user.companyId,
          typeOfFile: "recording",
        },
      };

      var res = await this.$http.get(
        this.$store.getters.ENDPOINT +
          "/attachments?filter=" +
          encodeURIComponent(JSON.stringify(filter))
      );

      this.files = _.map(res.body, (c) => {
        c.size = this.mathfloorCustom(c.size);
        c.createdOn = moment(c.createdOn).format("lll");
        return c;
      });

      this.loading = false;
      return this.files;
    },

    upgradeStorage() {},
    updateRecordCalls() {
      var self = this;

      self.$http
        .patch(
          `${this.$store.getters.ENDPOINT}/companies/${self.$store.getters.user.companyId}`,
          { recordCallsWithTrueCaller: self.recordCallsWithTrueCaller }
        )
        .then((response) => {
          self.$store.dispatch("getCompanyDetails", {
            companyId: self.$store.getters.user.companyId,
          });
          console.log("response", response.body);
        })
        .catch((err) => {
          self.$swal({
            type: "error",
            text: "Something went wrong. Couldn't Update",
          });
        });
    },
  },
};
</script>

<style scoped>
.step-number {
  font-size: 2.5rem;
  color: #4caf50;
  margin-bottom: 10px;
}

h2 {
  font-weight: bold;
  margin-bottom: 20px;
}
p {
  font-size: 16px;
  color: #555;
}
.v-card {
  border-radius: 12px;
  transition: all 0.3s ease;
  min-height: 200px;
  border-radius: 10px !important;
}
.v-card:hover {
  background-color: #f5f5f5;
  transform: translateY(-5px);
}
.selectable-card {
  cursor: pointer;
  transition: 0.3s ease;
}
.selectable-card:hover {
  background-color: #f5f5f5;
  transform: scale(1.02);
}

.active-card {
  background-color: #d6d6d6; /* Grey background for selected card */
  border: 2px solid #4caf50;
}

.customMarginBottom {
  margin-bottom: 6px !important;
}

@media (min-width: 1200px) {
  .recordPadding {
    padding-left: 30%;
    padding-right: 30%;
  }
}

/* Landscape tablets and medium desktops */
@media (min-width: 992px) and (max-width: 1199px) {
  .recordPadding {
    padding-left: 30%;
    padding-right: 30%;
  }
}

/* Portrait tablets and small desktops */
@media (min-width: 768px) and (max-width: 991px) {
  .recordPadding {
    padding-left: 20%;
    padding-right: 20%;
  }
}

/* Landscape phones and portrait tablets */
@media (max-width: 767px) {
  .recordPadding {
    padding-left: 1%;
    padding-right: 1%;
  }
}

/* Portrait phones and smaller */
@media (max-width: 480px) {
  .recordPadding {
    padding-left: 1%;
    padding-right: 1%;
  }
}
</style>
